export const ACCESS_STATUS = {
  NOT_APPLICABLE: "not_applicable",
  NEVER_INVITED: "never_invited",
  INVITED: "invited",
  INVITATION_EXPIRED: "invitation_expired",
  LOGGED_IN: "logged_in",
}

export const ACCESS_STATUS_LABELS = {
  [ACCESS_STATUS.NEVER_INVITED]: "Not invited",
  [ACCESS_STATUS.INVITED]: "Invited",
  [ACCESS_STATUS.INVITATION_EXPIRED]: "Invitation expired",
  [ACCESS_STATUS.LOGGED_IN]: "Active",
}

export const ACCESS_STATUS_BADGE_VARIANTS = {
  [ACCESS_STATUS.NEVER_INVITED]: "locked",
  [ACCESS_STATUS.INVITED]: "waiting",
  [ACCESS_STATUS.INVITATION_EXPIRED]: "error",
  [ACCESS_STATUS.LOGGED_IN]: "success",
}

/**
 * Which access state a user is in. Expiry comes from the server as
 * invitation_expires_at so the 7-day window lives in exactly one place.
 */
export const getAccessStatus = user => {
  if (!user?.admin_created) return ACCESS_STATUS.NOT_APPLICABLE
  if (user?.last_login_at) return ACCESS_STATUS.LOGGED_IN
  if (!user?.invitation_sent_at) return ACCESS_STATUS.NEVER_INVITED

  const expiresAt = user.invitation_expires_at ? new Date(user.invitation_expires_at) : null
  if (expiresAt && expiresAt.getTime() < Date.now()) return ACCESS_STATUS.INVITATION_EXPIRED

  return ACCESS_STATUS.INVITED
}

export const canSendInvitation = user =>
  [ACCESS_STATUS.NEVER_INVITED, ACCESS_STATUS.INVITED, ACCESS_STATUS.INVITATION_EXPIRED]
    .includes(getAccessStatus(user))
